import { render, staticRenderFns } from "./hetong.vue?vue&type=template&id=24134ed4&scoped=true"
import script from "./hetong.vue?vue&type=script&lang=js"
export * from "./hetong.vue?vue&type=script&lang=js"
import style0 from "./hetong.vue?vue&type=style&index=0&id=24134ed4&prod&lang=less&scoped=true"
import style1 from "./hetong.vue?vue&type=style&index=1&id=24134ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24134ed4",
  null
  
)

export default component.exports